<template>
  <Preview :caseData="detail" :user="{ name: name, avatar: avatar }"></Preview>
</template>

<script>
import { mapGetters } from "vuex";
import Preview from "@/components/Preview";
import {
  fetchHouseDraftData,
  fetchHouseEditData,
  fetchCustomDraftEditData,
  fetchCustomEditData,
} from "@/api";
export default {
  components: {
    Preview,
  },
  computed: {
    ...mapGetters("user", { name: "name", avatar: "avatar" }),
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isDraft: Boolean,
  },
  data() {
    return {
      detail: {},
    };
  },
  created() {
    if (this.item.type === "全屋案例") {
      this.getHouseDetail();
    } else {
      this.getCustomDetail();
    }
  },
  methods: {
    getHouseDetail() {
      if (this.isDraft) {
        this.getHouseDraftData(this.item.id);
      } else {
        this.getHouseEditData(this.item.id);
      }
    },
    getCustomDetail() {
      if (this.isDraft) {
        this.getCustomDraftData(this.item.id);
      } else {
        this.getCustomEditData(this.item.id);
      }
    },

    // 全屋
    getHouseDraftData(draftId) {
      fetchHouseDraftData(draftId).then((res) => {
        this.detail = res.data;
        this.loading = false;
      });
    },
    getHouseEditData(projectId) {
      fetchHouseEditData(projectId).then((res) => {
        this.detail = res.data;
        this.detail.draftId = 0;
        this.loading = false;
      });
    },
    // 自定义
    getCustomDraftData(draftId) {
      fetchCustomDraftEditData(draftId).then((res) => {
        this.detail = res.data;
        this.loading = false;
      });
    },
    getCustomEditData(projectId) {
      fetchCustomEditData(projectId).then((res) => {
        this.detail = res.data;
        this.detail.draftId = 0;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>